import { LitElement, html, customElement, property, css, unsafeCSS } from "lit-element";
// Notwendig:
/*
APP.augmentedReality()

*/

class OcArScreen extends LitElement {
    static get properties() {
        return {
            active: { type: Boolean },
            ocar: { type: Object },
        };
    }

    render() {
        return this.active
            ? html`
                ${this.style()}
                  <div class="container">
                      <div class="text" id="oc-ar-screen-text">${I18N("ARScreenText")}</div>
                      <button @click=${this.ar} class="arButton">
                          <img id="oc-ar-screen-img"
                              src="https://developers.google.com/ar/develop/java/images/ic_view_in_ar_new_googblue_48dp.png"
                          />
                          <p id="oc-ar-screen-title">${I18N("ARScreenAR")}</p>
                      </button>
                      <button @click=${this.back} id="oc-ar-screen-btn-back">${I18N("ARScreenBack")}</button>
                  </div>
              `
            : html``;
    }

    updated() {
        // To be sure its infront!
        document.getElementsByTagName("body")[0].append(this);
    }

    ar() {
        this.ocar.start();
    }

    back() {
        this.active = false;
        this.performUpdate();
    }

    createRenderRoot() {
        return this;
    }

    style() {
        return html`
            <style>

                oc-ar-screen .container {
                    position: fixed;
                    left: 0px;
                    top: 0px;
                    height: 100%;
                    width: 100%;
                    background-color: rgba(255, 255, 255, 0.97);
                    z-index: 2147483647;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    align-items: center;
                    height: 100%;
                    width: 100%;
                }

                oc-ar-screen .text {
                    padding-left: 30px;
                    padding-right: 30px;
                    text-align: center;
                }

                oc-ar-screen .arButton {
                    height: 300px;
                    width: 300px;
                    border-radius: 150px;
                    display: flex;
                    justify-content: space-evenly;
                    align-items: center;
                }

                oc-ar-screen button {
                    background-color: #4caf50; /* Green */
                    border: none;
                    color: white;
                    padding: 8px 16px;
                    text-align: center;
                    text-decoration: none;
                    display: inline-block;
                    margin: 4px 2px;
                    -webkit-transition-duration: 0.4s; /* Safari */
                    transition-duration: 0.4s;
                    cursor: pointer;
                    -webkit-transition-duration: 0.4s; /* Safari */
                    transition-duration: 0.4s;
                    background-color: white;
                    color: black;
                    border: 2px solid #e7e7e7;
                }
                oc-ar-screen button:hover {
                    background-color: #e7e7e7;
                }
            </style>
        `
    }

}
customElements.define("oc-ar-screen", OcArScreen);
